import { render, staticRenderFns } from "./ItemAfterHeading3.vue?vue&type=template&id=0a031f7e&"
import script from "./ItemAfterHeading3.vue?vue&type=script&lang=js&"
export * from "./ItemAfterHeading3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports